import { getLogger } from '@sbt-web/utils';

export const logger = getLogger({
  type: 'service',
  service_name: 'orodha',
  service_version: process.env.SERVICE_VERSION,
});

export default logger;
